import { ERROR_NOT_FINITE } from '../../logger/constants';
import { isFiniteNumber } from '../lang';
export function validateEventValue(log, maybeValue, method) {
    if (isFiniteNumber(maybeValue) || maybeValue == undefined) // eslint-disable-line eqeqeq
        return maybeValue;
    log.error(ERROR_NOT_FINITE, [method]);
    return false;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/utils/inputValidation/eventValue.js
// module id = 3853
// module chunks = 25